module.exports = __webpack_public_path__ + "static/media/entertainment.26a65d12.jpg";